import { CUSTOM_OBJECT_PREFIX, EXPANDABLE_NAV_GROUP, EXPANDABLE_NAV_GROUP_MAX_INITIAL_DISPLAY_ITEMS, VERTICAL_NAV_GROUP } from '../../components/VerticalNav/constants';
import { uuid4 } from '../../utils/uuid';
export const formatChildren = (children, formattedChildren = []) => {
  if (!children || !children.length) return [];
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (!child.id) {
      if (!child.children || child.children.length <= 0) {
        continue;
      }
      formattedChildren.push({
        id: `${VERTICAL_NAV_GROUP}-${uuid4()}`,
        children: formatChildren(child.children)
      });
      continue;
    }
    if (child.id.startsWith(CUSTOM_OBJECT_PREFIX)) {
      const customObjectGroup = {
        id: `${EXPANDABLE_NAV_GROUP}-${uuid4()}`,
        children: [],
        isExpanded: false
      };
      for (let j = i; j < children.length; j++) {
        const currentChild = children[j];
        if (!currentChild || !currentChild.id || !currentChild.id.startsWith(CUSTOM_OBJECT_PREFIX)) {
          break;
        }
        customObjectGroup.children.push({
          id: currentChild.id,
          children: []
        });
        i = j;
      }
      if (customObjectGroup.children.length <= EXPANDABLE_NAV_GROUP_MAX_INITIAL_DISPLAY_ITEMS) {
        formattedChildren.push(...customObjectGroup.children);
        continue;
      }
      formattedChildren.push(customObjectGroup);
      continue;
    }
    formattedChildren.push({
      id: child.id,
      children: formatChildren(child.children)
    });
  }
  return formattedChildren;
};
export function normalizeNavItems(navItems, normalizedNavItems, ancestorItems = [], primaryCategory) {
  for (const navItem of navItems) {
    const {
      id,
      children,
      path,
      sidebarMatchRegexes,
      sidebarExclusionRegexes
    } = navItem;
    const isHomeItem = id === 'home';
    if (id) {
      normalizedNavItems.byId[id] = Object.assign({}, navItem, {
        id,
        children: formatChildren(children),
        primaryCategory: primaryCategory || id,
        ancestors: ancestorItems,
        isBookmarked: false
      });
      if (sidebarMatchRegexes) {
        sidebarMatchRegexes.forEach(pathRegEx => {
          normalizedNavItems.byPath[pathRegEx] = {
            id,
            primaryCategory: primaryCategory || id
          };
        });
      }
      if (sidebarExclusionRegexes) {
        normalizedNavItems.verticalNavExclusionRoutes = normalizedNavItems.verticalNavExclusionRoutes.concat(sidebarExclusionRegexes);
      }
      if (!isHomeItem && path && !(sidebarMatchRegexes && sidebarMatchRegexes.length > 0)) {
        normalizedNavItems.byPath[path.split('?')[0]] = {
          id,
          primaryCategory: primaryCategory || id
        };
      }
      if (!primaryCategory && !isHomeItem) {
        normalizedNavItems.primaryNav.navItems.push({
          id,
          children: formatChildren(children)
        });
      }
    }
    if (children) {
      normalizeNavItems(children, normalizedNavItems, id ? [...ancestorItems, id] : ancestorItems, primaryCategory || id);
    }
  }
  return normalizedNavItems;
}
export function getNormalizedNavItems(navConfigData) {
  const normalizedNavItems = normalizeNavItems(navConfigData.children, {
    byId: {},
    byPath: {},
    primaryNav: {
      navItems: []
    },
    sidebarDefaultsMapping: {},
    openMenus: {
      primary: undefined,
      secondary: []
    },
    activeItem: undefined,
    focusedItem: undefined,
    verticalNavExclusionRoutes: []
  }, []);
  return normalizedNavItems;
}